import { render, staticRenderFns } from "./DefaultAttention.vue?vue&type=template&id=5f7aefcd&scoped=true&"
import script from "./DefaultAttention.vue?vue&type=script&lang=ts&"
export * from "./DefaultAttention.vue?vue&type=script&lang=ts&"
import style0 from "./DefaultAttention.vue?vue&type=style&index=0&id=5f7aefcd&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7aefcd",
  null
  
)

export default component.exports